const sizeCategories = [
  { name: 'S', value: 'S', illustration: 'eli1n', unit: 'S' },
  { name: 'M', value: 'M', illustration: 'medium-package', unit: 'M' },
  { name: 'L', value: 'L', illustration: 'large-package', unit: 'L' },
];

const weights = {
  se: {
    S: [
      { name: '50 g', abbreviation: 'g', value: 50 },
      { name: '100 g', abbreviation: 'g', value: 100 },
      { name: '250 g', abbreviation: 'g', value: 250 },
      { name: '500 g', abbreviation: 'g', value: 500 },
      { name: '1 kg', abbreviation: 'kg', value: 1000 },
      { name: '2 kg', abbreviation: 'kg', value: 2000 },
    ],
    M: [
      { name: '1 kg', abbreviation: 'kg', value: 1000 },
      { name: '2 kg', abbreviation: 'kg', value: 2000 },
      { name: '3 kg', abbreviation: 'kg', value: 3000 },
      { name: '5 kg', abbreviation: 'kg', value: 5000 },
      { name: '10 kg', abbreviation: 'kg', value: 10000 },
      { name: '15 kg', abbreviation: 'kg', value: 15000 },
      { name: '20 kg', abbreviation: 'kg', value: 20000 },
    ],
    L: [
      { name: '3 kg', abbreviation: 'kg', value: 3000 },
      { name: '5 kg', abbreviation: 'kg', value: 5000 },
      { name: '10 kg', abbreviation: 'kg', value: 10000 },
      { name: '15 kg', abbreviation: 'kg', value: 15000 },
      { name: '20 kg', abbreviation: 'kg', value: 20000 },
    ],
  },
  dk: {
    S: [
      { name: '50 g', abbreviation: 'g', value: 50 },
      { name: '100 g', abbreviation: 'g', value: 100 },
      { name: '250 g', abbreviation: 'g', value: 250 },
      { name: '500 g', abbreviation: 'g', value: 500 },
      { name: '1 kg', abbreviation: 'kg', value: 1000 },
      { name: '2 kg', abbreviation: 'kg', value: 2000 },
    ],
    M: [],
    L: [
      { name: '2 kg', abbreviation: 'kg', value: 2000 },
      { name: '5 kg', abbreviation: 'kg', value: 5000 },
      { name: '10 kg', abbreviation: 'kg', value: 10000 },
      { name: '15 kg', abbreviation: 'kg', value: 15000 },
      { name: '20 kg', abbreviation: 'kg', value: 20000 },
      { name: '25 kg', abbreviation: 'kg', value: 25000 },
      { name: '30 kg', abbreviation: 'kg', value: 30000 },
      { name: '35 kg', abbreviation: 'kg', value: 35000 },
    ],
  },
  dk01012024: {
    S: [
      { name: '100 g', abbreviation: 'g', value: 100 },
      { name: '250 g', abbreviation: 'g', value: 250 },
      { name: '500 g', abbreviation: 'g', value: 500 },
      { name: '1 kg', abbreviation: 'kg', value: 1000 },
      { name: '2 kg', abbreviation: 'kg', value: 2000 },
    ],
    M: [],
    L: [
      { name: '2 kg', abbreviation: 'kg', value: 2000 },
      { name: '5 kg', abbreviation: 'kg', value: 5000 },
      { name: '10 kg', abbreviation: 'kg', value: 10000 },
      { name: '15 kg', abbreviation: 'kg', value: 15000 },
      { name: '20 kg', abbreviation: 'kg', value: 20000 },
      { name: '25 kg', abbreviation: 'kg', value: 25000 },
      { name: '30 kg', abbreviation: 'kg', value: 30000 },
      { name: '35 kg', abbreviation: 'kg', value: 35000 },
    ],
  },
};

const RealValues = {
  WebUrl: 'https://riktigavykort.postnord.se/sv',
  AndroidAppUrl: 'https://play.google.com/store/apps/details?id=se.posten.riktigavykort&hl=sv',
  AndroidImg: 'https://com-inte.postnord.com/globalassets/icons/logos-and-badges/google-play-badge_se.svg',
  IosAppUrl: 'https://apps.apple.com/se/app/riktiga-vykort/id444458799?l=sv',
  IosImg: 'https://com-inte.postnord.com/globalassets/icons/logos-and-badges/app_store_badge_se_rgb_blk.svg',
};

const sendDirectUrl = 'https://portal.postnord.com/skickadirekt/';

const stampShopUrl = 'https://shop.postnord.se/ebutik/default.aspx';

const productDescriptionUrl = 'https://se-inte.postnord.com/skicka-forsandelser/brev-och-vykort/';

export { weights, sizeCategories, sendDirectUrl, stampShopUrl, RealValues };
